import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <section id="precio" className="py-24 bg-[#FAF7F2] relative scroll-mt-4" data-id="element-10">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-11">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-[#1B5E5E]" data-id="element-12">
          Recupera Tus Rodillas Hoy
        </h2>

        <p className="text-xl md:text-2xl text-gray-700 mb-12 leading-relaxed" data-id="element-13">
          No esperes a que el dolor sea insoportable. Comienza el Protocolo de
          21 Días ahora y vuelve a caminar con confianza.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-14">
          <CTAButton text="Sí, Quiero Mi Copia Ahora" className="w-full sm:w-auto px-12 py-6 text-2xl" data-id="element-15" />

          <div className="flex items-center gap-2 text-gray-600 mt-4" data-id="element-16">
            <ShieldCheck className="w-6 h-6 text-green-600" data-id="element-17" />
            <span className="text-lg font-medium" data-id="element-18">
              Pago 100% Seguro y Privado
            </span>
          </div>
        </div>
      </div>
    </section>;
}